module.exports = __webpack_public_path__ + "img/1.0 AR_Dashboard.86ec79bf.jpg";